import {EmploymentSalary, Kta, ShiftSalary} from "./queries";
import { NameIdOption } from "../../../common/types/commonTypes";
import { Nullable } from "../../../common/types/nullable";
import {AccumDateData, KtaAvg} from "../../employment/employmentApi";

export enum SalaryIncreaseStatus {
  IDLE = "IDLE",
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
  DONE = "DONE", // just possibly done (for filtering out KTAs with deltas)
}

export interface SalaryWarning {
  type: SalaryWarningType;
  params?: Record<string, string>;
}

export enum SalaryWarningType {
  FUTURE_SALARIES = "FUTURE_SALARIES",
  INCOMPATIBLE_SALARY_COMPONENTS = "INCOMPATIBLE_SALARY_COMPONENTS",
}

// query responses converted to UI
export interface SalaryRowBase {
  id: string;
  version: number;
  hrRepresentative: Nullable<NameIdOption>;
  salaryIncrease: Record<string, string>;
  status: SalaryIncreaseStatus;
  warnings?: SalaryWarning[];
  unclear: boolean;
}

export interface ShiftSalaryRow
  extends SalaryRowBase,
    Omit<ShiftSalary, "workTitleId" | "hrRepresentative"> {
  workTitle: NameIdOption;
}

export interface EmploymentSalaryRow
  extends SalaryRowBase,
    Omit<EmploymentSalary, "hrRepresentative"> {
    workTitle: NameIdOption;
}

export interface KtaRow
    extends Omit<Kta, "hrRepresentative">, Omit<SalaryRowBase, "salaryIncrease" | "hrRepresentative"> {
    hrRepresentative: Nullable<NameIdOption>;
    raiseDateKta: Nullable<AccumDateData>
    salaryIncrease: Record<string, string>;
    contEmpId: string;
    raisedKta: KtaAvg;
    raisedKtaDate: string;
    currentKta: Record<string, string>; //
    currentOngoingKta: KtaAvg;
    raisedKeskiansio: string;
    currentKeskiansio: string;
    status: SalaryIncreaseStatus;
}

export interface GroupedEmploymentSalaryRow extends EmploymentSalaryRow {
  groupedEmploymentRows: Array<EmploymentSalaryRow>
  uniqueWorkTitles: string;
  expanded: boolean;
}

export interface GroupedShiftSalaryRow extends ShiftSalaryRow {
  groupedShiftRows: Array<ShiftSalaryRow>
  expanded: boolean;
}

export type GroupedSalaryTableRow = GroupedEmploymentSalaryRow | GroupedShiftSalaryRow;
export type SalaryTableRow = GroupedEmploymentSalaryRow | GroupedShiftSalaryRow | ShiftSalaryRow | EmploymentSalaryRow | KtaRow;
export type SalaryTableRows = SalaryTableRow[];

export type BulkSalaryIncreaseFormValues = {
  data: SalaryTableRows;
};
